import React, { FC, useCallback, useState } from 'react';
import gksLogoLight from 'assets/img/gksLogo.png';
import gksLogoDark from 'assets/img/gksLogoDark.png';

import BuiltOnEnkrateia from 'components/BuiltOnEnkrateia/BuiltOnEnkrateia';
import PoweredBy from 'components/PoweredBy/PoweredBy';
import Footer from 'components/Footer/Footer';

import { DoubleChevronRight } from '../SvgIcons';

import './SideBar.scss';

export interface SideBarProps {
  children: React.ReactNode;
  variant?: 'traro' | 'kliparo' | 'prosfora';
  collapsible?: boolean;
  initiallyCollapsed?: boolean;
  className?: string;
}

const SideBar: FC<SideBarProps> = ({
  children,
  variant = 'traro',
  collapsible = false,
  initiallyCollapsed = false,
  className = '',
}) => {
  const [open, setOpen] = useState(!initiallyCollapsed);
  const toggleOpen = useCallback(() => {
    setOpen((prev) => !prev);
  }, []);

  const colorVariant = variant === 'prosfora' ? 'dark' : 'light';
  const gksLogo = variant === 'prosfora' ? gksLogoDark : gksLogoLight;

  return (
    <aside className={`enkrateia-sidebar variant-${variant} ${className} ${open ? 'open' : 'closed'}`}>
      {open && (
        <>
          {children}
          <div className="flex-grower" />
          <div className="footnote">
            <img src={gksLogo} alt="GKS" width={80} />
            {variant !== 'prosfora' && <BuiltOnEnkrateia variant={colorVariant} />}
            <PoweredBy variant={colorVariant} />
            <Footer variant={colorVariant} />
          </div>
        </>
      )}
      {collapsible && (
        <button onClick={toggleOpen} type="button" className="enkrateia-sidebar-collapse-button">
          <DoubleChevronRight color="white" />
        </button>
      )}
    </aside>
  );
};

export default SideBar;
